import type { AppearanceComponent, AppearanceRow } from '@setplex/tria-api'

import React from 'react'
import {
  BANNERS_CONTENT,
  getIsRow,
  ROWS_CONTENT,
} from '~/features/appearance/components'
import { Banner } from '../components/banner'
import { Row } from '../components/row'

/*
 * Choose component by type from dynamic components list.
 */
export function getComponent(contentType: AppearanceComponent['contentType']) {
  if (ROWS_CONTENT[contentType]) return Row
  if (BANNERS_CONTENT[contentType]) return Banner

  try {
    throw new Error(`Component not found for type: ${contentType}`)
  } catch (ignore) {
    return React.Fragment
  }
}

// helper function for style
export function style(
  size: 'S' | 'M' | 'L',
  orientation: 'HORIZONTAL' | 'VERTICAL'
) {
  return {
    posterSize: size,
    posterOrientation: orientation,
    background: {
      type: 'UNSET',
    },
  } as AppearanceRow['style']
}

// helper function for resource
export function resource(
  resource: string,
  fallback?: boolean | (() => Promise<unknown>)
) {
  return {
    path: resource.split('?')[0],
    search: new URLSearchParams(resource.split('?')[1]),
    fallback: fallback || undefined,
  } as AppearanceRow['resource']
}

// helper function for component
export function component(
  c: Partial<AppearanceComponent>,
  i: number
): AppearanceComponent {
  c.id = 'default_' + String(i + 1)

  const isRow = getIsRow(c)

  if (isRow) c.description = undefined

  return c as AppearanceComponent
}

export const HOME_BANNERS = {
  title: 'Banners',
  contentType: 'BANNER_CAROUSEL' as const,
  resource: resource('/v3/carousels/banners'),
  paged: false,
  refreshable: false,
}
